import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Plant, WKZNamePlant } from '@/types';
import { Checkbox, Autocomplete, TextField } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import Button from '@/components/UI/Button/Button';
import styles from './SeriesFisrtStepSelector.module.scss';

type SeriesFisrtStepSelectorProps = {
  checkEnabled: boolean;
  isPlants: boolean;
  modelSeries: string[];
  onSelectedSeries: (series: string[]) => void; // eslint-disable-line no-unused-vars
  plants: WKZNamePlant[];
  onSelectedPlants: (plant: Plant[]) => void; // eslint-disable-line no-unused-vars
};

const formatPlant = (plant: Plant) => `${plant?.plantName} (W${plant?.wkzNumber})`;

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const SeriesFisrtStepSelector: React.FC<SeriesFisrtStepSelectorProps> = (props) => {
  const { checkEnabled, modelSeries = [], plants = [], onSelectedPlants, onSelectedSeries, isPlants = false } = props;
  const [valueSeries, setValueSeries] = useState<string[] | undefined>([]);
  const [valuePlants, setValuePlants] = useState<Plant[] | undefined>([]);
  const { t } = useTranslation();

  const handleChangeSeries = (ev: React.SyntheticEvent, newValue: string[]) => setValueSeries(newValue);

  const handleChangePlants = (ev: React.SyntheticEvent, newValue: Plant[]) => setValuePlants(newValue);

  const handleNext = () => (isPlants ? onSelectedPlants(valuePlants || []) : onSelectedSeries(valueSeries || []));

  return (
    <div className={styles.FisrtStepSelect}>
      <Autocomplete
        multiple
        disabled={checkEnabled}
        disableClearable={valueSeries?.length === 0 || valuePlants?.length === 0}
        disableCloseOnSelect
        id={`autocomplete_${isPlants ? 'add_plants' : 'add_series'}`}
        options={(isPlants ? plants : modelSeries) as string[]}
        // @ts-ignore
        getOptionLabel={isPlants ? formatPlant : (option) => option}
        // @ts-ignore
        onChange={isPlants ? handleChangePlants : handleChangeSeries}
        renderInput={(params) => (
          <TextField {...params} variant="outlined" placeholder={t(`affectedVehicles.${isPlants ? 'addPlants' : 'addSeries'}`)} margin="none" />
        )}
        renderOption={({ key, ...optionProps }: any, option: string | Plant, { selected }) => (
          <li key={key} {...optionProps}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {isPlants ? formatPlant(option as Plant) : (option as string)}
          </li>
        )}
        style={{ minWidth: 400 }}
        value={(isPlants ? valuePlants : valueSeries) as string[]}
      />
      <Button
        disabled={isPlants ? !valuePlants?.length : !valueSeries?.length}
        btnText={t('dialog.next')}
        handleClick={handleNext}
      />

    </div>
  );
};

export default SeriesFisrtStepSelector;
